

const ErrorPage = (props) => {
    const data = props.data;
    let content = "ErrorPage";
    if(data && data.content){
        content = data.content;
    }
    return (
        <div className="row">
            <div className="col-md-12">
                <div className='align-center mt-5' dangerouslySetInnerHTML={{
                    __html: content
                }}>
                </div>
            </div>
        </div>
    );
}

export default ErrorPage;